import { Checkbox, InputAdornment, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import { ValidatedNumberInput } from "../../../../../common/inputs/ValidatedInputs";

const textFieldStyle = (editing) => {
    if (!editing) {
        return {
            '& .MuiOutlinedInput-root': {
                '& fieldset': { borderWidth: '0' },
            },
            '& .MuiInputLabel-root': {
                color: (theme) => `${theme.palette.text.secondary} !important`,
            },
            '& .MuiOutlinedInput-input': {
                WebkitTextFillColor: (theme) => `${theme.palette.text.primary} !important`
            },
            '& .MuiAutocomplete-endAdornment': {
                display: 'none'
            }
        }
    }
    else return null;
}

const RatesTable = (props) => {
    const { editable, onEnableRate, data, onChangeRate, roomId, disabled } = props;

    if (!data) {
        return null;
    }

    const plans = data;

    return <Table sx={{ minWidth: 150 }} aria-label="simple table">
        <TableHead>
            <TableRow>
                <TableCell>Rate Plan</TableCell>
                <TableCell align="center">Enabled</TableCell>
                <TableCell align="center">Price per night</TableCell>
            </TableRow>
        </TableHead>
        <TableBody>
            {plans.map((plan, index) => {
                const rowId = `room-${roomId}-plan-${plan.id}`;

                return <TableRow
                    key={plan.id}
                    sx={{
                        '&:last-child td, &:last-child th': { border: 0 },
                        height: '75px'
                    }}
                >
                    <TableCell component="th" scope="row">
                        {plan.name}
                    </TableCell>
                    <TableCell align="center" sx={{ minWidth: '50px', padding: '16px 0px' }}>
                        {editable && <Checkbox
                            checked={plan.enabled}
                            disabled={disabled}
                            onChange={(evt) => onEnableRate(rowId, plan.id, evt.target.checked)}
                            inputProps={{ 'aria-label': 'controlled' }} />}
                        {!editable && (plan.enabled ? <CheckIcon sx={{ color: "green" }} /> : <CloseIcon sx={{ color: "red" }} />)}
                    </TableCell>
                    <TableCell align="center" sx={{ padding: '0px' }}>
                        {plan.enabled ? <ValidatedNumberInput
                            index={index}
                            margin="dense"
                            id={rowId}
                            min={1}
                            required
                            onChange={(id, value, valid) => onChangeRate(id, plan.id, value, valid)}
                            disabled={!editable || disabled}
                            sx={{
                                width: "100px",
                                ...textFieldStyle(editable),
                            }}
                            value={plan.price}
                            size="small"
                            InputProps={{
                                endAdornment: <InputAdornment position="end">zł</InputAdornment>,
                            }}
                            inputProps={{
                                sx: {
                                    textAlign: 'right'
                                }
                            }}
                            hideButtons
                            disableHelperText
                        /> : "-"}
                    </TableCell>
                </TableRow>
            })}
        </TableBody>
    </Table>
}

export default RatesTable;